__turbopack_context__.v({
  "productAttributes": "styles-module__u4ut1G__productAttributes",
  "productAttributesContainer": "styles-module__u4ut1G__productAttributesContainer",
  "videoIcon": "styles-module__u4ut1G__videoIcon",
});
